import React from 'react';

export interface StatusIndicatorStyle02Props {
  online: boolean;
  label?: string;
  size?: 'small' | 'medium' | 'large';
  pulse?: boolean;
}

/**
 * StatusIndicator Style 02 - Dot
 * Simple colored dot indicator with optional pulse animation
 */
export const Style02_Dot: React.FC<StatusIndicatorStyle02Props> = ({
  online,
  label,
  size = 'medium',
  pulse = true
}) => {
  const sizeClasses = {
    small: 'w-2 h-2',
    medium: 'w-3 h-3',
    large: 'w-4 h-4'
  };

  return (
    <div className="inline-flex items-center gap-2">
      <span className="relative flex">
        <span className={`${sizeClasses[size]} rounded-full ${
          online ? 'bg-green-500' : 'bg-red-500'
        }`} />
        {pulse && online && (
          <span className={`absolute inset-0 ${sizeClasses[size]} rounded-full bg-green-500 animate-ping opacity-75`} />
        )}
      </span>
      {label && (
        <span className={`text-xs ${online ? 'text-green-400' : 'text-red-400'}`}>
          {label}
        </span>
      )}
    </div>
  );
};

export default Style02_Dot;
